// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"Autocomplete__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Autocomplete/Autocomplete.scss
 ** module id = 886
 ** module chunks = 1
 **/